const UsersRoles = {
  superAdmin: {
    name: 'superAdmin',
    canCreate: ['partner'],
    canEdit: ['partner'],
    canDelete: ['partner'],
  },
  partner: {
    name: 'partner',
    canCreate: [],
    canEdit: [],
    canDelete: [],
  },
};

const isSuperAdmin = user => user?.usersRole?.name === UsersRoles.superAdmin.name;

const isPartner = user => user?.usersRole?.name === UsersRoles.partner.name;

export { isSuperAdmin, isPartner };
